
import { computed, defineComponent, reactive } from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import ServicoPlanoAssinatura from '@/servicos/PainelAdministrativo/ServicoPlanoAssinatura';

export default defineComponent({
  name: 'SelecionarPlanoAssinatura',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: Number || undefined,
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite para selecionar',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados'],
  setup(props, { emit }) {
    const { montaOpcoesComListaConsultaRapida } = useTelaBase();

    let debounce = 0;
    const servicoPlanoAssinatura = new ServicoPlanoAssinatura();

    const state = reactive({
      listaPlanoAssinaturas: [] as IOption[],
      fetching: false,
      emDigitacao: false,
    });

    async function obterPlanoAssinaturaPorCodigo(valor: any) {
      if (state.emDigitacao) { return; }
      if (!UtilitarioGeral.valorValido(valor)) { return; }
      if (!(valor > 0)) { return; }

      if (props.varios) {
        if (props.codigosSelecionados.length === 0) { return; }
      } else if (props.codigoSelecionado === 0) {
        return;
      }
      let efetuarConsulta = true;

      if (UtilitarioGeral.validaLista(state.listaPlanoAssinaturas)) {
        if (props.varios) {
          const listaCodigosConsulta = state.listaPlanoAssinaturas.map((c) => c.value);
          const diferencas = props.codigosSelecionados.filter((c) => !listaCodigosConsulta.includes(c));
          if (!UtilitarioGeral.validaLista(diferencas)) {
            efetuarConsulta = false;
          }
        } else {
          const existeLista = state.listaPlanoAssinaturas.find((c) => c.value === props.codigoSelecionado);
          if (existeLista !== undefined) {
            efetuarConsulta = false;
          }
        }
      }

      if (!efetuarConsulta) return;

      state.listaPlanoAssinaturas = [];

      const parametrosConsultaRapida: IParametrosConsultaRapida = {
        apenasAtivos: false, recursoAssociado: '',
      };

      if (props.varios) {
        parametrosConsultaRapida.filtrarPorVariosCodigos = true;
        parametrosConsultaRapida.valores = valor;
      } else {
        parametrosConsultaRapida.filtrarPorCodigo = true;
        parametrosConsultaRapida.valor = valor;
      }
      const listaPlanoAssinaturas = await servicoPlanoAssinatura.consultaRapida(parametrosConsultaRapida);
      state.listaPlanoAssinaturas = montaOpcoesComListaConsultaRapida(listaPlanoAssinaturas);
    }

    async function pesquisarPlanoAssinatura(valorPesquisa: any) {
      state.emDigitacao = true;

      if (!UtilitarioGeral.valorValido(valorPesquisa)) { return; }

      state.listaPlanoAssinaturas = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const parametrosConsultaRapida: IParametrosConsultaRapida = {
          valor: valorPesquisa, apenasAtivos: true, recursoAssociado: '',
        };

        parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();

        const listaPlanoAssinaturas = await servicoPlanoAssinatura.consultaRapida(parametrosConsultaRapida);
        state.listaPlanoAssinaturas = montaOpcoesComListaConsultaRapida(listaPlanoAssinaturas);
      }, 600);
    }

    function obterPlanoAssinatura():any {
      obterPlanoAssinaturaPorCodigo(props.codigoSelecionado);
      return (props.codigoSelecionado === 0 ? undefined : props.codigoSelecionado);
    }

    const computedCodigoSelecionado = computed({
      get: () => obterPlanoAssinatura(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
      },
    });

    function obterPlanoAssinaturas():number[] {
      obterPlanoAssinaturaPorCodigo(props.codigosSelecionados);
      return props.codigosSelecionados;
    }

    const computedCodigosSelecionados = computed({
      get: () => obterPlanoAssinaturas(),
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    return {
      props,
      state,
      pesquisarPlanoAssinatura,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
    };
  },
});
